import React from 'react'
import styled from 'styled-components'
import { timeConvert } from '../helpers/functions'

// CSS Grid is amazing, but we still have to do some tweaking with grid-row-start and grid-row-end to dinamically position our events following the rules specified in the requirements.
// To know more about the problems behind indefinite spans, take a look at this GitHub issue --> https://github.com/w3c/csswg-drafts/issues/388#issue-169858519
// You can find the function I wrote for this specific use case in src/helpers/functions (populateBuckets)

const Container = styled.div`
  position: absolute;
  height: 100%;
  opacity: 0.9;

  background-color: white;
  height: 100%;
  
  display: flex;
  flex-direction: ${props => props.singleLine ? 'row' : 'column'};

  &::before{
    content:'';
    position: absolute;
    left: 0;
    height: 100%;
    width: 10px;
    background-color: #00ae00;
  }

  width: ${props => 100 / props.totlen}%;
  left: ${props => 100 / props.totlen * props.index}%;
  grid-row-start: ${props => !props.allday && props.start && props.start[2] === '3' ? Number(props.start.slice(0,2)) * 2 + 2 : Number(props.start.slice(0,2)) * 2 + 1};
  grid-row-end: ${props => !props.allday && props.end && props.end[2] === '3' ? Number(props.end.slice(0,2)) * 2 + 2 : Number(props.end.slice(0,2)) * 2 + 1};
`

const Start = styled.p`
  margin-top: ${props => props.singleLine && props.allday ? '4px' : props.singleLine && !props.allday ? '12px' : '8px'};
  margin-left: 20px;
  margin-bottom: 2px;
  color: #939393;
`
const Name = styled.p`
  margin-top: ${props => props.singleLine && props.allday ? '4px' : props.singleLine && !props.allday ? '12px' : null};
  margin-left: ${props => props.singleLine ? '6px' : '20px'};
  margin-bottom: 2px;
  font-weight: 700;
`
const Location = styled.p`
  margin-top: ${props => props.singleLine && props.allday ? '4px' : props.singleLine && !props.allday ? '12px' : null};
  margin-left: ${props => props.singleLine ? '10px' : '20px'};
  color: #00ae00;
  font-weight: 600;
`

const AllDayEvent = styled.div`
  display: flex;
  flex-direction: row;
  background-color: white;
  position: relative;
  border-top: 4px solid #E6E6E6;
  border-bottom: 4px solid #E6E6E6;
  
  &::after{
    content: '';
    height: calc(100% + 8px);
    position: absolute;
    left: -12rem;
    width: 100%;
    background-color: #E6E6E6;
    z-index: -100;
    top: -4px;
  }
  &::before{
    content:'';
    position: absolute;
    left: 0;
    height: 100%;
    width: 10px;
    background-color: #00ae00;
  }
`

export default function Event (props) {
  if (props.info.allday) {
    return (
    <AllDayEvent>
        <Start singleLine={true} allday={props.info.allday}>ALLDAY -</Start>
        <Name singleLine={true} allday={props.info.allday}>{props.info.name}</Name>
        <Location singleLine={true} allday={props.info.allday}>{props.info.location}</Location>
    </AllDayEvent>
    )
  }
  return (
    <Container allday={props.info.allday} singleLine={props.info.end - props.info.start === 30 || props.info.end - props.info.start === 70} totlen={props.totlen} index={props.index} start={props.info.start && props.info.start} end={props.info.end && props.info.end}>
        <Start singleLine={props.info.end - props.info.start === 30 || props.info.end - props.info.start === 70} totlen={props.totlen} allday={props.info.allday}>{timeConvert[props.info.start]}</Start>
        <Name singleLine={props.info.end - props.info.start === 30 || props.info.end - props.info.start === 70} totlen={props.totlen} allday={props.info.allday}>{props.info.name}</Name>
        <Location singleLine={props.info.end - props.info.start === 30 || props.info.end - props.info.start === 70} totlen={props.totlen} allday={props.info.allday}>{props.info.location}</Location>
    </Container>
  )
}